import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { Route } from 'src/app/models/enums/Route.enum';
import { ScrollService } from 'src/app/services/scroll.service';
import { Subscription } from 'rxjs';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-main',
  imports: [
    SharedModule,
    HeaderComponent,
    FooterComponent,
    SidenavComponent
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {

  public showBulgariBackground: boolean = true;
  public scrollSubscription!: Subscription;
  public showScrollButton: boolean = false;

  constructor(
    private readonly router: Router,
    public readonly scrollService: ScrollService,
  ) { }

  ngOnInit(): void {

    this.router.events.subscribe(() => {
      const url = this.router.url;
      if (url === `/${Route.HomePage}`) {
        this.showBulgariBackground = true;
      } else {
        this.showBulgariBackground = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.scrollService.mountScrollService();
    if (this.scrollService.showGoTopBtn$) {
      this.scrollSubscription = this.scrollService.showGoTopBtn$.subscribe((showBtn: boolean) => {
        this.showScrollButton = showBtn;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

}
